export function parseAppRouterTarget(url: string) {
  const questionIndex = url.indexOf('?')
  const path = questionIndex === -1 ? url : url.slice(0, questionIndex)
  const query = questionIndex === -1 ? '' : url.slice(questionIndex + 1)
  const search = Object.fromEntries(new URLSearchParams(query).entries())

  return {
    to: path || '/',
    search
  }
}
